// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/opt/buildhome/repo/src/models/common';
import model_2 from '/opt/buildhome/repo/src/pages/diagnosis/model';

export const models = {
model_1: { namespace: 'common', model: model_1 },
model_2: { namespace: 'diagnosis.model', model: model_2 },
} as const
